module.exports = __webpack_public_path__ + "img/linear_scale.1878e2eb.svg";